var map = {
	"./BG1.png": "b543",
	"./BG2.png": "60e8",
	"./bls-1.png": "041c",
	"./bls-2.png": "0d40",
	"./bls-3.png": "a921",
	"./bls-4.png": "2670",
	"./bls-5.png": "929d",
	"./bls-6.png": "abd6",
	"./e3-mascot.png": "5efd",
	"./preview.png": "c1f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c4f";